(function (){
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .factory('StandardReportFilter', FilterClass);

  function FilterClass(ReportFormat,DateUtil, DeviceTypeFilter, RegionFilter, ProductHierarchyFilter, DetailLevelFilter) {

    function fetchFilter(dimensionArr, dimensionKey) {
      var dimension = _(dimensionArr).find({'name': dimensionKey});
      return dimension ? dimension.values : [];
    }

    function getTimezone(timezones) {
      return timezones.length > 1 ? 'Multiple Time Zones' : _.head(timezones);
    }

    function setData(data, filterStateParams, that) {
      that.deviceType = DeviceTypeFilter(fetchFilter(data, 'deviceType'), filterStateParams).values();
      that.region = RegionFilter(fetchFilter(data, 'region'), filterStateParams).values();
      that.hierarchy = ProductHierarchyFilter(fetchFilter(data, 'hierarchy'), filterStateParams,
          'All').values();
      that.addressableHierarchy = ProductHierarchyFilter(fetchFilter(data, 'addressable_hierarchy'),
          filterStateParams, 'All TrueFit Addressable').values();
      that.detailLevel = DetailLevelFilter(ReportFormat, filterStateParams).values();
      that.timezone = getTimezone(fetchFilter(data, 'str_timezone'));
      var maxAllowedDate =  _.max(_.map(fetchFilter(data, 'updatedDate'), DateUtil.formatToYearMonthDay));
      var defaultStartDate = DateUtil.formatToYearMonthDay(moment(maxAllowedDate).subtract(1, 'months'));
      that.dateRange = {
        startDate: filterStateParams.startDate ||defaultStartDate,
        endDate: filterStateParams.endDate || maxAllowedDate
      };
      that.maxAllowedDate = maxAllowedDate;
      that.addressable = filterStateParams.addressable || false;
      return that;
    }

    /**
     * @params data : filter object
     *
     * @Output object : {region: [], deviceType: [], dateRange: {}...}
     * */

    function Filter(data, filterStateParams) {
      if (!(this instanceof Filter)) return new Filter(data, filterStateParams);
      setData(data, filterStateParams, this);
      this.reset = function(){ return setData(data, {}, this);}
    }

    return Filter;
    }
  
})();